import { render, staticRenderFns } from "./CityContent2.vue?vue&type=template&id=53173568&scoped=true"
import script from "./CityContent2.vue?vue&type=script&lang=js"
export * from "./CityContent2.vue?vue&type=script&lang=js"
import style0 from "./CityContent2.vue?vue&type=style&index=0&id=53173568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53173568",
  null
  
)

export default component.exports